module.exports = __webpack_public_path__ + "static/media/ug_logo_xmas_dunkel.b053c2f1.png";